import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const stockSettingsSlice = createSlice({
    name: "stockSettings",
    initialState: {
        success: false,
        fail: false,
        settings: null,
        responseData: null,
        errorDetailData: null,
    },
    reducers: {
        doGetStockSettingsSuccess: (state, action) => {
            state.settings = action.payload.data;
        },
        doGetStockSettingsFail: (state) => {
            state.settings = null;
        },
        doUpdateStockSettingsSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
            state.responseData = action.payload;
        },
        doUpdateStockSettingsFail: (state, action) => {
            state.success = false;
            state.fail = true;
            state.errorDetailData = action.payload;
        },
        resetStockSettingsStateSuccess: (state) => {
            state.success = false;
            state.fail = false;
            state.errorDetailData = null;
        },
    },
});

export const doGetStockSettings = () => async (dispatch) => {
    try {
        const response = await axios.get(`/api/admin/stock-settings`);
        dispatch(doGetStockSettingsSuccess(response.data));
    } catch (error) {
        dispatch(doGetStockSettingsFail(error.response));
    }
};

export const doUpdateStockSettings = (param) => async (dispatch) => {
    try {
        const response = await axios.put(`/api/admin/stock-settings`, param);
        dispatch(doUpdateStockSettingsSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateStockSettingsFail(error.response));
    }
};

export const resetStockSettingsState = () => async (dispatch) => {
    dispatch(resetStockSettingsStateSuccess());
};

export const {
    doGetStockSettingsSuccess,
    doGetStockSettingsFail,
    doUpdateStockSettingsSuccess,
    doUpdateStockSettingsFail,
    resetStockSettingsStateSuccess,
} = stockSettingsSlice.actions;

export const getStockSettings = (state) => state.stockSettings?.settings;
export const getStockSettingsSuccess = (state) => state.stockSettings?.success;
export const getStockSettingsFail = (state) => state.stockSettings?.fail;
export const getStockSettingsErrorData = (state) => state.stockSettings?.errorDetailData;

export default stockSettingsSlice.reducer;
